import React from "react";

export default ({ value = 0 }) => (
  <div>
    <span>{new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value)}</span>
  </div>
);
